import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';

const MapTransportTaskList = (props) => {
  const { value, onItemColumnClick } = props;
  const { conditions: conditionItems, task } = value;

  return (
    <Box component='div' sx={{ width: '100%', height: '100%' }}>
      <List
        disablePadding
        sx={(theme) => ({
          padding: theme.spacing(0),
          border: '1px solid',
          borderColor: theme.palette.divider,
          borderRadius: theme.shape.borderRadius,
          overflow: 'hidden',
        })}>
        <ListItem
          disablePadding
          sx={(theme) => ({
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            zIndex: '2',
            pointerEvents: 'none',
            padding: theme.spacing(0),
            '.MuiListItemText-root': {
              display: 'flex',
              justifyContent: 'space-between',
              height: '100%',
              position: 'relative',
              flex: 'none',
              '&:before': {
                content: '""',
                position: 'absolute',
                top: '0',
                right: '0',
                height: '100%',
                bgcolor: theme.palette.divider,
                width: '1px',
                zIndex: '1',
                pointerEvents: 'none',
              },
              '&:last-of-type': {
                flex: '1',
                '&:before': {
                  display: 'none',
                },
              },
            },
          })}>
          {config.mapTransportTaskColumns.map((column) => (
            <ListItemText key={column.name} style={{ width: column.width }} />
          ))}
        </ListItem>
        <ListItem
          disablePadding
          sx={(theme) => ({
            width: '100%',
            userSelect: 'none',
            borderRadius: '0',
            '.MuiListItemText-root': {
              display: 'flex',
              flex: 'none',
              margin: theme.spacing(0),
              padding: theme.spacing(1),
              alignItems: 'center',
              bgcolor: 'background.default',
              borderBottom: '1px solid',
              borderColor: theme.palette.divider,
              '&:first-of-type': {
                paddingLeft: theme.spacing(2),
              },
              '&:last-of-type': {
                flex: '1',
                paddingRight: theme.spacing(2),
              },
              '.MuiTypography-root': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              },
            },
          })}>
          {config.mapTransportTaskColumns.map((column) => (
            <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
              <Typography>{column.label}</Typography>
            </ListItemText>
          ))}
        </ListItem>
        {task.ttn_task.map((task, key) => (
          <ListItem
            key={key}
            disablePadding
            sx={(theme) => ({
              width: '100%',
              userSelect: 'none',
              borderRadius: '0',
              '.MuiListItemText-root': {
                display: 'flex',
                flex: 'none',
                margin: theme.spacing(0),
                padding: theme.spacing(0.5, 1),
                alignItems: 'center',
                '&:first-of-type': {
                  paddingLeft: theme.spacing(2),
                },
                '&:last-of-type': {
                  flex: '1',
                  paddingRight: theme.spacing(2),
                },
                '.MuiTypography-root': {
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                },
              },
            })}>
            {config.mapTransportTaskColumns.map((column) => {
              switch (column.name) {
                case 'section':
                  return (
                    <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                      <Typography>{task.section}</Typography>
                    </ListItemText>
                  );
                case 'gs_num':
                  return (
                    <ListItemText
                      key={column.name}
                      disableTypography
                      onClick={() => onItemColumnClick(task)}
                      sx={{
                        width: column.width,
                        cursor: task.geofence_id ? 'pointer' : 'default',
                      }}>
                      <Typography>{task.gs_num}</Typography>
                    </ListItemText>
                  );
                case 'product':
                  return (
                    <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                      <Typography>{task.product}</Typography>
                    </ListItemText>
                  );
                case 'volume':
                  return (
                    <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                      <Typography>{task.volume}</Typography>
                    </ListItemText>
                  );
                case 'dut':
                  return (
                    <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                      <Typography>
                        {Object.prototype.hasOwnProperty.call(conditionItems[conditionItems.length - 1].data, `dut${task.section}`)
                          ? conditionItems[conditionItems.length - 1].data[`dut${task.section}`] === config.conditions.dut.default
                            ? '0'
                            : conditionItems[conditionItems.length - 1].data[`dut${task.section}`]
                          : '0'}
                      </Typography>
                    </ListItemText>
                  );
              }
            })}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MapTransportTaskList;
